"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var doggyEgg = {
    name: "doggy",
    enabled: false,
    trigger: {
        type: "keys",
        keystrokes: ["d", "o", "g", "g", "y"],
        captureOnInputs: false
    },
    onStart: function () {
        var data = "https://i.imgur.com/PwxV3zM.gif";
        var shock = document.createElement("div");
        var img = new Image();
        img.src = data;
        img.style.width = "450px";
        img.style.height = "350px";
        img.style.transition = "4s all linear";
        img.style.position = "fixed";
        img.style.left = "-400px";
        img.style.bottom = "calc(-50% + 300px)";
        img.style.zIndex = "999999";
        document.body.appendChild(img);
        // window.setTimeout(function(){
        //   img.style.left = 'calc(50% - 200px)'
        // },50)
        window.setTimeout(function () {
            img.style.left = "calc(100% + 500px)";
        }, 50);
        window.setTimeout(function () {
            img.parentNode.removeChild(img);
        }, 6000);
    },
};
exports.default = doggyEgg;
